import { render, staticRenderFns } from "./institutionHome.vue?vue&type=template&id=3cd3977c&scoped=true&"
import script from "./institutionHome.vue?vue&type=script&lang=js&"
export * from "./institutionHome.vue?vue&type=script&lang=js&"
import style0 from "./institutionHome.vue?vue&type=style&index=0&id=3cd3977c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd3977c",
  null
  
)

export default component.exports